import { Image } from 'models'

export const imgUrlToImage = (url: string): Image => {
  return new Image({
    id: null,
    contentType: null,
    url,
    label: null,
    mainImage: null,
    originalHeight: null,
    originalWidth: null,
    portrait: null,
    portraitWidth: null,
    portraitX: null,
    portraitY: null,
    square: null,
    squareWidth: null,
    squareX: null,
    squareY: null
  })
}
